<template>
  <v-data-table
    sort-by="name"
    class="elevation-0 general-table  main-top-margin"
    :headers="headers"
    :items="clients"
    :search="search"
    @click:row="editClient"
    :loading="isLoading"
    :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
  >
    <template v-slot:header.name="{ header }">
      <lang t="CLIENTS-TBL-HEADER-NAME"></lang>
    </template>

    <template v-slot:header.warehouses.length="{ header }">
      <lang t="CLIENTS-TBL-HEADER-WAREHOUSES_COUNT"></lang>
    </template>

    <template v-slot:header.itemCount="{ header }">
      <lang t="CLIENTS-TBL-HEADER-ARTICLES_COUNT"></lang>
    </template>

    <template v-slot:top>
      <div class="d-flex align-center flex-wrap py-2 mb-6">
        <v-text-field
          clearable
          class="general-table__search general-table__search--short"
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          :label="$t('GLOBAL-DO_SEARCH')"
          solo
          flat
          dense
          hide-details
        >
        </v-text-field>

        <v-spacer></v-spacer>
        <Button type="outside-label" icon="mdi-plus" :label="$t('CLIENTS-BTN-NEW_CLIENT')" @click="newClient()" />

        <v-dialog v-model="dialog" max-width="640px" :persistent="false">
          <v-card>
            <v-card-title>
              <span class="headline"><lang :t="currentDialogTitle"></lang></span>

              <v-spacer></v-spacer>

              <v-btn icon light @click="dialogClose">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-window v-model="windowStep">
                <v-window-item :value="1">
                  <v-form ref="form1" v-model="form1Valid" lazy-validation>
                    <v-text-field v-model="editedItem.name" label="Mandant Name" required :rules="[rules.required, rules.name]"></v-text-field>

                    <v-row>
                      <v-col cols="6">
                        <v-select
                          v-model="editedItem.language_id"
                          :items="languages"
                          item-text="name"
                          item-value="id"
                          :label="$t('CLIENTS-CLIENT-DEFAULT_LANGUAGE')"
                          required
                          :rules="[rules.required]"
                        >
                        </v-select>
                      </v-col>

                      <v-col cols="6">
                        <v-select
                          v-model="editedItem.unitSystem"
                          :items="unitSystems"
                          :label="$t('CLIENTS-CLIENT-UNITS_SCHEMA')"
                          required
                          :rules="[rules.required]"
                        >
                        </v-select>
                      </v-col>

                      <v-col cols="12">
                        <v-switch v-model="createAdministrator" :label="$t('CLIENTS-CLIENT-NEW-USER')"></v-switch>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-window-item>

                <v-window-item :value="2">
                  <v-form ref="form2" v-model="form2Valid" lazy-validation>
                    <v-text-field
                      required
                      v-model="editedItem.username"
                      :label="$t('CLIENT-USERNAME')"
                      :rules="[rules.required, rules.name]"
                    ></v-text-field>
                    <v-text-field
                      required
                      v-model="editedItem.email"
                      :error-messages="errors.email"
                      :label="$t('CLIENT-EMAIL')"
                      :rules="[rules.required, rules.email]"
                    ></v-text-field>
                    <password-field v-model="editedItem.password" label="CLIENT-PASSWORD" />
                    <v-text-field
                      required
                      :hint="$t('CLIENT-PASSWORD_HINT')"
                      :label="$t('CLIENT-PASSWORD-RE_ENTER')"
                      v-model="editedItem.rePassword"
                      type="password"
                      :rules="[rules.required, passwordConfirmationRule]"
                    ></v-text-field>
                  </v-form>
                </v-window-item>

                <v-window-item :value="3">
                  <div class="pa-4 text-center">
                    <div class="d-flex justify-center">
                      <v-icon size="96" color="success">mdi-check-circle-outline</v-icon>
                    </div>
                    <span class="caption"><lang t="CLIENTS-CLIENT_SUCCESSFULLY_CREATED"></lang></span>
                  </div>
                </v-window-item>
              </v-window>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn v-if="windowStep < 3" :disabled="windowStep === 1 || windowStep === 3" text @click="windowStep--"
                ><lang t="GLOBAL-BTN-BACK"></lang
              ></v-btn>

              <v-spacer></v-spacer>

              <template v-if="windowStep == 1">
                <v-btn
                  :disabled="windowStep === 3 || !form1Valid"
                  :loading="isSaving"
                  elevation="0"
                  light
                  rounded
                  color="themeColor"
                  @click="nextStep()"
                  ><lang t="GLOBAL-BTN-NEXT"></lang
                ></v-btn>
              </template>

              <template v-else-if="windowStep == 2">
                <!-- || !form2Valid -->
                <v-btn :disabled="windowStep === 3" :loading="isSaving" elevation="0" light rounded color="themeColor" @click="nextStep()"
                  ><lang t="GLOBAL-BTN-NEXT"></lang
                ></v-btn>
              </template>

              <template v-else-if="windowStep == 3">
                <v-btn :loading="isSaving" elevation="0" light rounded color="themeColor" @click="dialogFin()">schließen</v-btn>
              </template>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template v-slot:item.warehouses="{ item }">
      {{ getWarehouseNames(item.warehouses) }}
    </template>

    <template v-slot:item.itemCount="{ item }">
      <display-number :number="item.itemCount" />
    </template>
    <template v-slot:footer.page-text="props" v-if="(clients.length > 0)">
      <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
      <display-number :number="clients.length" />
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon small class="pa-1" color="grey darken-2" @click.stop="editClient(item)">mdi-pencil</v-icon>
      <v-icon small class="pa-1" color="secondary" @click.stop.prevent="deleteClient(item)" :disabled="!item.isDeleteable"
        >mdi-trash-can-outline</v-icon
      >
    </template>

    <template v-slot:no-data>
      <v-btn flat color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import passwordField from "@/components/PasswordField";
import Button from "../../components/ui-elements/Button.vue";
import DisplayNumber from "../../components/DisplayNumber.vue";

export default {
  name: "ClientIndex",
  components: { passwordField, Button, DisplayNumber },

  data() {
    var self = this;

    return {
      isSaving: false,
      isLoading: true,
      dialog: false,
      search: "",
      windowStep: 1,

      createAdministrator: false,
      errors: {
        email: [],
      },

      headers: [
        {
          text: "Mandant",
          align: "start",
          sortable: true,
          value: "name",
          class: "general-table__th--3",
        },
        { text: "Lager", value: "warehouses", sortable: false, class: "general-table__th--3" },
        { text: "Artiekl", value: "itemCount", sortable: false, class: "general-table__th--3" },
        { text: "", value: "actions", sortable: false, align: "end", width: "80px" },
      ],

      clients: [],

      editedIndex: -1,
      editedItem: {
        name: "",
        username: null,
        email: null,
        password: null,
        language_id: null,
        unitSystem: null,
      },
      defaultItem: {
        name: "",
        username: null,
        email: null,
        password: null,
        language_id: null,
        unitSystem: null,
      },

      form1Valid: true,
      form2Valid: true,

      languages: [
        {
          id: 1,
          name: "Deutsch",
          shortcode: "de",
        },
        {
          id: 2,
          name: "Englisch",
          shortcode: "en",
        },
        {
          id: 3,
          name: "Spanish",
          shortcode: "es",
        },
      ],

      unitSystems: [
        {
          text: "metrisch",
          value: "metric",
        },
        {
          text: "imperial",
          value: "imperial",
        },
      ],
    };
  },

  computed: {
    currentDialogTitle() {
      switch (this.windowStep) {
        case 1:
          return "CLIENTS-CLIENT-NEW";
        case 2:
          return "CLIENTS-CLIENT-NEW-USER";
        default:
          return "";
      }
    },
    getWarehouseNames() {
      return (item) => {
        if (!Array.isArray(item)) return "";
        const names = item.map((el) => el.name);
        if (names) return names.join(", ");
        return "";
      };
    },

    passwordConfirmationRule() {
      return this.editedItem.password === this.editedItem.rePassword || this.$t("GLOBAL-FORM-PASSWORDS_MUST_MATCH");
    },
  },

  watch: {
    dialog(val) {
      val || this.dialogClose();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.isLoading = true;

      this.axios.get("mandates").then((res) => {
        this.isLoading = false;
        this.clients = res.data;
      });
    },

    newClient() {
      this.form1Valid = true;
      this.form2Valid = true;
      this.dialog = true;
    },

    nextStep() {
      if (this.windowStep == 1) {
        if (this.$refs.form1.validate()) {
          if (this.createAdministrator === true) {
            this.windowStep++;
          } else {
            this.isSaving = true;

            let mandate = {
              name: this.editedItem.name,
              language_id: this.editedItem.language_id,
              unitSystem: this.editedItem.unitSystem,
            };

            this.axios.post("mandates", mandate).then((res) => {
              this.windowStep = 3;
              this.isSaving = false;
            });
          }
        }
      } else if (this.windowStep == 2) {
        if (this.$refs.form2.validate()) {
          this.isSaving = true;

          let mandate = {
            name: this.editedItem.name,
            language_id: this.editedItem.language_id,
            unitSystem: this.editedItem.unitSystem,
          };

          this.axios
            .post("mandates", mandate)
            .then((res) => {

              if (this.createAdministrator) {
                let user = {
                  mandate_id: res.data.id,
                  name: this.editedItem.username,
                  email: this.editedItem.email,
                  password: this.editedItem.password,
                  language_id: this.editedItem.language_id,
                  unitSystem: this.editedItem.unitSystem,
                  role: "adm",
                };

                this.axios
                  .post("users", user)
                  .then((result) => {
                    this.windowStep++;
                    this.isSaving = false;
                  })
                  .catch((error) => {
                    if (error.response) {

                      if (error.response.status == 422) {
                        this.errors = error.response.data.errors;
                        this.form2Valid = true;
                      }
                    }
                    this.isSaving = false;
                  });
              }
            })
            .catch((error) => {
              console.error(error);
              this.isSaving = false;
            });
        }
      }
    },

    dialogClose() {
      this.dialog = false;
      this.isSaving = false;

      this.windowStep = 1;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    dialogFin() {
      this.dialog = false;
      this.initialize();
    },

    editClient(item) {
      this.$router.push({ name: "client", params: { id: item.id } });
    },

    deleteClient(item) {
      this.$confirm(this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { NAME: item.name }), {
        title: this.$t("GLOBAL-CONFIRMATION-DELETE-TITLE"),
        buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
        buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
      }).then((res) => {
        if (res) {
          this.axios.delete("mandates/" + item.id).then((res) => {
            this.initialize();
            this.$store.dispatch("setSnackbar", { text: this.$t("GLOBAL-SUCCESSFULLY_DELETED") });
          });
        }
      });
    },

    save() {
      this.isSaving = true;
      let snackMsg = "";

      if (this.editedIndex > -1) {
        Object.assign(this.clients[this.editedIndex], this.editedItem);
        snackMsg = this.$t("GLOBAL-SUCCESSFULLY_SAVED");
      } else {
        this.clients.push(this.editedItem);
        snackMsg = this.$t("GLOBAL-SUCCESSFULLY_SAVED");
      }

      setTimeout(() => {
        this.dialogClose();
        this.$store.dispatch("setSnackbar", { text: snackMsg });
      }, 1250);
    },
  },
};
</script>

<style lang="scss"></style>
